import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { ApiService } from '../../../../services/api.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { billingOrganisation, paymentMethod } from '../../models';
declare var Stripe;

@Component({
    selector: 'app-payment-method-stripe',
    templateUrl: './payment-method-stripe.component.html',
    styleUrls: ['./payment-method-stripe.component.scss']
})
export class PaymentMethodStripeComponent implements OnInit, OnChanges {
    @ViewChild('cardNumber') private cardNumberEl: ElementRef;
    @ViewChild('cardCvc') private cardCvcEl: ElementRef;
    @ViewChild('cardExpiry') private cardExpiryEl: ElementRef;

    cardHolderName: string;
    stripe; // : stripe.Stripe;
    cardNumber;
    cardCvc;
    cardExpiry;
    cardErrors;
    valid = false;
    submitted = false;

    loading = false;
    confirmation;

    id: string;
    @Input() organisation: billingOrganisation;
    @Input() signupMode = false;
    method: paymentMethod;
    loadingRequest = true;
    form: FormGroup;

    @Output() methodCreated = new EventEmitter<paymentMethod>();
    @Output() methodRequestCreated = new EventEmitter<boolean>();

    constructor(private api: ApiService,
        private fb: FormBuilder
    ) { }

    ngOnInit(): void {
        this.form = this.fb.group({
            cardHolderName: ['', Validators.required]
        });
    }

    ngOnChanges(changes: SimpleChanges) {
        if (!this.organisation) {
          return;
        }
        this.id = this.organisation.safeId;
        this.createPayment();  
        
    }

    async createPayment(){
        if (this.signupMode) {
            const p = await this.api.createSignupPaymentRequest(this.id, "Stripe");    //.subscribe(p => {
            this.setupCardForm(p.data);
            
        } else {
            const p = await this.api.createPaymentMethod(this.id, "Stripe");  //.subscribe(p => {
            this.setupCardForm(p.data);
        }
    }

    setupCardForm(p: paymentMethod) {
        this.method = p;
    
        this.stripe = Stripe(p.metaData);
        const elements = this.stripe.elements();
        let classes = {
             base: 'form-control'
        };
    
        this.form.controls['cardHolderName'].setValue('');
        this.cardNumber = elements.create('cardNumber', { classes: classes });
        this.cardCvc = elements.create('cardCvc', { classes: classes });
        this.cardExpiry = elements.create('cardExpiry', { classes: classes });
    
        this.cardNumber.mount(this.cardNumberEl.nativeElement);
        this.cardCvc.mount(this.cardCvcEl.nativeElement);
        this.cardExpiry.mount(this.cardExpiryEl.nativeElement);
    
        this.cardNumber.addEventListener('change', ({ error }) => {
            this.handleCardError(error);
        });
        this.cardCvc.addEventListener('change', ({ error }) => {
            this.handleCardError(error);
        });
        this.cardExpiry.addEventListener('change', ({ error }) => {
            this.handleCardError(error);
        });
    
        this.loadingRequest = false;
        this.methodRequestCreated.emit(true);
    }
    
    handleCardError(error) {
        this.cardErrors = error && error.message;
    }
    
    handleForm(e) {
        e.preventDefault();
    
        if (!this.form.valid) {
            this.submitted = true;
            this.valid = false;
            return;
        }
    
        this.loading = true;
        this.stripe.handleCardSetup(
            this.method.providerRequestId,
            this.cardNumber,
            {
                payment_method_data: {
                    billing_details: { name: this.form.controls['cardHolderName'].value }
                }
            }
        ).then(result => {
            
            if (result.error) {
                // Display error.message in your UI.
                this.cardErrors = result.error.message;
                this.loading = false;
            } else {
                // The setup has succeeded. Display a success message.
                this.method.providerToken = result.setupIntent.payment_method;
                this.method.methodName = this.form.controls['cardHolderName'].value;
                if (this.signupMode) {
                    this.api.completeSignupPaymentRequest(this.method).then(r => {
                        this.methodCreated.emit(this.method);
                        this.loading = false;
                    });
                } else {
                    this.api.completePaymentMethod(this.id, this.method).then(r => {
                        this.methodCreated.emit(this.method);
                        this.loading = false;
                    });
                }
            }
        });
    }

}
